import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { UUID } from 'angular2-uuid';
import { HttpClientModule, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable()
export class ClaveUnicaService {
    public url;
    public bodyData = {
        /* "clientId": environment.clientId,
        "clientSecret": environment.clientSecret,
        "redirectUrl": environment.redirectUrl, */
        "clientName": "PENAFLOR",
        "endpoint": "https://accounts.claveunica.gob.cl"
    }
    public api = environment.claveUnicaUrl;
    public apiUrl = environment.backUrl;
    constructor(
        private _http: HttpClient,
    ) {
    }

    getToken(): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json'
        });

        let body = this.bodyData;

        // Realizar la solicitud POST enviando el body
        return this._http.post(this.api + `/clave-unica/generate-url`, body, { headers: headers })
            .pipe(map((response: any) => response)); // Procesar la respuesta
    }

    getInfoCiudadano(code, state): Observable<any> {
        let headers = new HttpHeaders({
            'Content-type': 'application/json'
        });

        // Definir los parámetros
        let params = new HttpParams()
            .set('code', code)
            .set('state', state);

        let body = this.bodyData;

        // Realizar la solicitud POST enviando el body
        return this._http.post(this.api + `/clave-unica/info-ciudadano`, body, { headers: headers, params: params })
            .pipe(map((response: any) => response)); // Procesar la respuesta
    }




    // ✅ Guardar datos y obtener token
    guardarDatos(datos: any): Observable<{ token: string }> {
        return this._http.post<{ token: string }>(`${this.apiUrl}/guardar-datos`, datos);
    }

    // ✅ Obtener datos de sesión con `token`
    obtenerSesion(token: string): Observable<{ token: string; datos: any }> {
        return this._http.get<{ token: string; datos: any }>(`${this.apiUrl}/obtener-sesion/${token}`);
    }

    async logoutClaveUnica(): Promise<any> {
        window.location.href = 'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout';

    }

}
